import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-mt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_password_input = _resolveComponent("password-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_mfa_login = _resolveComponent("mfa-login")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar_title, { class: "text-center" }, {
            default: _withCtx(() => [
              _createTextVNode(" Login ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      (!_ctx.response || !_ctx.response.nextAction)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
          }, [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_input, {
                  label: "Email",
                  type: "email",
                  name: "email",
                  modelValue: _ctx.command.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.command.email) = $event)),
                  outlined: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_password_input, {
                  class: "q-mt-md",
                  label: "Password",
                  modelValue: _ctx.command.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.command.password) = $event)),
                  outlined: ""
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_router_link, { to: "/recover-password" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Forgot password")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_q_toggle, {
                  class: "q-mt-md",
                  modelValue: _ctx.command.remember,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.command.remember) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Stay logged in ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_async_btn, {
                  type: "submit",
                  task: _ctx.task,
                  label: "Login",
                  color: "primary",
                  class: "full-width"
                }, null, 8, ["task"])
              ]),
              _: 1
            })
          ], 32))
        : (_ctx.response && _ctx.response.nextAction)
          ? (_openBlock(), _createBlock(_component_mfa_login, {
              key: 1,
              command: _ctx.command,
              "user-id": _ctx.response.user.id,
              onSuccess: _ctx.onLogin
            }, null, 8, ["command", "user-id", "onSuccess"]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}